import { AudioResult } from "interfaces/sessions";
import { max as dateFnsMax} from 'date-fns'

/**
 * Format milliseconds to a human-readable time string (MM:SS or HH:MM:SS)
 */
export const formatMsToTimeString = (timeMs: number): string => {
  const timeInSeconds = timeMs / 1000;
  
  // Handle hours for longer recordings
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
  const seconds = Math.round(timeInSeconds % 60).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
  
  return hours > 0 
    ? `${hours}:${minutes}:${seconds}`
    : `${minutes}:${seconds}`;
};

/**
 * Calculate total duration from audio data
 */
export const calculateTotalDuration = (audioData: AudioResult[], scheduled_start: Date): number => {
  if (!audioData || audioData.length === 0) return 0;
  const adjustedAudioMap = audioData.map((x, idx) => {return {'value': x, 'idx': idx}}).filter((v) => v.value.audio_status === 'UPLOADED' )
  const end = dateFnsMax(adjustedAudioMap.map((x) => x.value.end))
  return end.getTime() - scheduled_start.getTime()
}; 